export default __webpack_public_path__ + "static/media/email_popup.cedd195f.gif";